(() => {
  const form = document.getElementById('ajax-contact-form');
  if (!form) return;

  const submitBtn = document.getElementById('ContactSubmit');
  const feedback = document.getElementById('contact-feedback');

  const setBusy = (busy) => {
    if (!submitBtn) return;
    if (busy) {
      submitBtn.disabled = true;
      submitBtn.dataset.originalText = submitBtn.textContent || 'Send';
      submitBtn.textContent = 'Sending...';
    } else {
      submitBtn.disabled = false;
      submitBtn.textContent = submitBtn.dataset.originalText || 'Send';
    }
  };

  const showMessage = (type, html) => {
    if (!feedback) return;
    feedback.innerHTML = `<div class="contact-${type}">${html}</div>`;
  };


  // Use capture so we run BEFORE theme/app listeners, then block them.
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    // stopImmediatePropagation doesn’t work on passive listeners; capture helps.
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    feedback && (feedback.innerHTML = '');
    setBusy(true);

    try {
      // If your form action is "/contact#contact_form", remove the hash for the fetch
      const rawAction = form.getAttribute('action') || '/contact#contact_form';
      const action = rawAction.replace(/#.*/, '') || '/contact';

      const fd = new FormData(form);

      // Guarantee required Shopify field
      if (!fd.get('form_type')) fd.append('form_type', 'contact');
      // Dawn normally includes 'utf8' automatically; not strictly necessary but harmless:
      if (!fd.get('utf8')) fd.append('utf8', '✓');

      // Client-side checks (Message is optional)
      const required = [
        ['contact[name]', 'Name'],
        ['contact[email]', 'Email'],
        ['contact[phone]', 'Phone'],
      ];

      // Clear previous error states
      required.forEach(([name]) => {
        const el = form.querySelector(`[name="${CSS.escape(name)}"]`);
        if (el) {
          el.classList.remove('is-invalid');
          el.setAttribute('aria-invalid', 'false');
        }
      });

      const missing = required.filter(([k]) => !String(fd.get(k) || '').trim());
      if (missing.length) {
        missing.forEach(([name]) => {
          const el = form.querySelector(`[name="${CSS.escape(name)}"]`);
          if (el) {
            el.classList.add('is-invalid');
            el.setAttribute('aria-invalid', 'true');
          }
        });
        showMessage('error', `Please fill out: ${missing.map(([, label]) => label).join(', ')}.`);
        setBusy(false);
        return;
      }

      // Basic email + phone sanity
      const email = String(fd.get('contact[email]') || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        const el = form.querySelector('[name="contact[email]"]');
        el?.classList.add('is-invalid');
        el?.setAttribute('aria-invalid', 'true');
        showMessage('error', 'Please enter a valid email address.');
        setBusy(false);
        return;
      }
      const digits = String(fd.get('contact[phone]') || '').replace(/\D/g, '');
      if (digits.length < 6) {
        const el = form.querySelector('[name="contact[phone]"]');
        el?.classList.add('is-invalid');
        el?.setAttribute('aria-invalid', 'true');
        showMessage('error', 'Please enter a valid phone number.');
        setBusy(false);
        return;
      }

      // Submit to Shopify. It returns HTML (often after a redirect), so we parse it.
      const res = await fetch(action, {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: {
          'Accept': 'text/html, */*',
          'X-Requested-With': 'XMLHttpRequest'
        },
        redirect: 'follow'
      });

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      console.log(doc);
      // Our Liquid markers from the {% form 'contact' %} block:
      const successMarker = doc.querySelector('[data-contact-status="success"]');
      const errorMarker = doc.querySelector('[data-contact-status="error"]');
      const errorPayload = errorMarker?.getAttribute('data-contact-errors');

      // if (successMarker) {
        form.reset();
        showMessage('success', 'Thank you! Your message has been sent.');
      // } else if (errorMarker) {
      //   let msg = 'There was a problem with your submission.';
      //   try {
      //     const errors = JSON.parse(errorPayload || '{}');
      //     const list = Object.entries(errors)
      //       .map(([k, v]) => `<li><strong>${k}</strong>: ${v}</li>`)
      //       .join('');
      //     if (list) msg = `<ul>${list}</ul>`;
      //   } catch (_) {}
      //   showMessage('error', msg);
      // } else {
      //   // Fallback for themes that don’t render our markers after redirect
      //   const genericError =
      //     doc.querySelector('.form__message, .errors, [role="alert"]')?.innerHTML ||
      //     'Unexpected response. Please try again.';
      //   // Heuristic: 400/422 usually means reCAPTCHA or validation fail
      //   if (!res.ok) {
      //     showMessage('error', genericError);
      //   } else {
      //     showMessage('error', genericError);
      //   }
      // }
    } catch (err) {
      showMessage('error', 'Network error. Please check your connection and try again.');
    } finally {
      setBusy(false);
    }
  }, { capture: true }); // capture: true is important to beat other listeners
})();
